// calculates next indexes for nudging elements in a list
// supplies warning if nudge would move element out of list

type NudgeDir = 'up' | 'down'

export default class NudgeIndexer {
  static parse(dir: NudgeDir, i: number, length: number) {
    let j: number
    let warning: string | undefined
    if (dir == 'up') {
      if (i === 0) {
        warning = 'Already at the top'
      }
      j = i - 1
    } else {
      if (i + 1 === length) {
        warning = 'Already at the bottom'
      }
      j = i + 1
    }

    return {
      j,
      warning
    }
  }
}

